import { Controller } from 'stimulus'

export default class PrototypePage extends Controller {
  static targets = ['svg', 'horizontalTemplate', 'verticalTemplate', 'iframeContainer']

  displayIframe() {
    this.iframeContainerTarget.classList.add('is-loaded')
  }
}
